var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAt = function SvgAt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8.03C2 4.7 4.7 2 8.03 2c3.073 0 4.463.97 5.159 2.021.753 1.14.872 2.625.872 4.01v1.211a.94.94 0 1 1-1.88 0V4.88a1 1 0 0 0-1.933-.359 4.152 4.152 0 1 0 .588 6.57 2.94 2.94 0 0 0 5.225-1.848V8.03c0-1.403-.094-3.433-1.204-5.112C13.688 1.151 11.563 0 8.03 0a8.03 8.03 0 0 0 0 16.06 1 1 0 1 0 0-2A6.03 6.03 0 0 1 2 8.03Zm3.879 0a2.152 2.152 0 1 1 4.303 0 2.152 2.152 0 0 1-4.303 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgAt;